var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsReciboLibre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#498FED",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.599 8.8v3c0 .33.269.6.6.6h9.6c.331 0 .6-.27.6-.6v-3h1.2v3c0 .993-.806 1.8-1.8 1.8h-9.6c-.994 0-1.8-.807-1.8-1.8v-3h1.2zM6.949.152l4.5 4.443-.844.854L7.6 2.482V10H6.4V2.413L3.402 5.45l-.854-.844 4.4-4.453z",
    transform: "translate(-507 -661) translate(507 661) translate(1 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsReciboLibre);
export default __webpack_public_path__ + "static/media/icons-recibo-libre.00184781.svg";
export { ForwardRef as ReactComponent };